import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { navigate } from "../../lib/router";
import type { ProjectDetail } from "@shared/schema";
import SceneCard from "./SceneCard";

export default function SceneBoard({ project }: { project: ProjectDetail }) {
  const qc = useQueryClient();
  const refresh = () => qc.invalidateQueries({ queryKey: ["project", project.id] });

  const genFrames = useMutation({ mutationFn: () => api.generateAll(project.id), onSuccess: refresh });
  const genVideos = useMutation({ mutationFn: () => api.generateVideos(project.id), onSuccess: refresh });

  if (project.status === "planning") {
    return (
      <div className="empty">
        <div className="big"><span className="spinner" style={{ width: 28, height: 28 }} /></div>
        <h2>Розбиваємо референс на сцени…</h2>
        <div>Claude формує сцени та промпти. Це займе до хвилини — сторінка оновиться сама.</div>
      </div>
    );
  }

  if (project.scenes.length === 0) {
    return (
      <div className="empty">
        <div className="big">🎬</div>
        <h2>Сцен ще немає</h2>
        <div>Спочатку зроби аналіз і розбий референс на сцени.</div>
        <div style={{ marginTop: 16 }}>
          <button className="btn primary" onClick={() => navigate(`/projects/${project.id}/analysis`)}>
            До аналізу
          </button>
        </div>
      </div>
    );
  }

  const aiScenes = project.scenes.filter((s) => s.kind === "ai_generated");

  return (
    <>
      <div className="toolbar">
        <div style={{ flex: 1, fontWeight: 600 }}>
          {project.scenes.length} сцен · {aiScenes.length} AI · {project.progress.framesReady} кадрів · {project.progress.videosReady} відео
        </div>
        <button className="btn" onClick={() => genFrames.mutate()} disabled={genFrames.isPending}>
          {genFrames.isPending ? <span className="spinner" /> : "Згенерувати всі перші кадри"}
        </button>
        <button className="btn" onClick={() => genVideos.mutate()} disabled={genVideos.isPending || project.progress.framesReady === 0}>
          {genVideos.isPending ? <span className="spinner" /> : "Згенерувати всі відео"}
        </button>
      </div>

      <div className="grid" style={{ gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))" }}>
        {project.scenes.map((scene) => (
          <SceneCard key={scene.id} scene={scene} projectId={project.id} />
        ))}
      </div>
    </>
  );
}
